

























import SvgIcon from '@/icons/SvgIcon.vue';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

type Value = Array<[string, string]>;

@Component({
    components: {SvgIcon},
})
export default class MatrixControl extends Vue {
    @Prop({type: String, required: true})
    public readonly parameterId: string;

    @Prop({type: Array, required: true})
    public readonly rows: string[];

    @Prop({type: Array, required: true})
    public readonly columns: string[];

    @Prop({required: true})
    public readonly value: Value | null;

    protected combinations: Value = [];

    protected created(): void {
        const value = this.value;

        if (value === null) {
            this.combinations = [];
        } else {
            this.combinations = [...value];
        }
    }

    protected isChecked(row: string, column: string): boolean {
        return this.combinations.some(([checkedRow, checkedColumn]) => checkedRow === row && checkedColumn === column);
    }

    protected onChecked(row: string, column: string, checked: boolean): void {
        this.combinations = checked
            ? [[row, column], ...this.combinations]
            : this.combinations.filter(([checkedRow, checkedColumn]) => checkedRow !== row || checkedColumn !== column)
                .sort((a, b) => a.join().localeCompare(b.join()));
    }

    @Watch('combinations')
    protected selectedValueChanged(): void {
        if (this.combinations.length === 0) {
            this.$emit('input', null);
            return;
        }

        this.$emit('input', this.combinations);
    }
}
